export const formatDate = (date) => {
    const dateInstance = new Date(date);
    const language = localStorage.getItem('language') === 'es' ? 'es-ES' : 'pt-BR';
    const day = dateInstance.getDate();
    const year = dateInstance.getFullYear();
    const month = dateInstance.toLocaleDateString(language, { month: 'long' });
    const hours = dateInstance.getHours();
    const minutes = dateInstance.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return `${day.toString()} - ${month.charAt(0).toUpperCase() + month.slice(1)} - ${year.toString()} | ${formattedTime}`;
};
